import type { ReactNode } from 'react';
import type { GlobalAreaProps } from '../../global-area';
import { GlobalArea } from '../../global-area';
import { ErrorViewTmpl } from './ErrorViewTmpl';

interface ErrorTemplateProps extends GlobalAreaProps {
  children?: ReactNode;
  title: string;
}

export function ErrorPageTmpl(props: ErrorTemplateProps) {
  const { title, children, ...restProps } = props;

  return (
    <>
      <GlobalArea {...restProps} />
      <ErrorViewTmpl title={title}>{children}</ErrorViewTmpl>
    </>
  );
}
